import KYRVendorAppointmentComponent from './KYRVendorAppointmentComponent'
import {VENDOR_APPOINTMENT_TYPE_PERSONAL_TRAINING} from '../../KYRConstants'
import AbstractKYRScreen from '../AbstractKYRScreen'
import React from 'react'

export default class KYRPersonalTrainingComponent extends AbstractKYRScreen {
  render() {
    return <KYRVendorAppointmentComponent type={VENDOR_APPOINTMENT_TYPE_PERSONAL_TRAINING} navParams={this.props.navParams} />
  }
}
